@if (
  ((showDesktopNavVersion$ | async) && !showMobileNavVersion && navbarItems.length > 0) ||
  (showMobileNavVersion && (mobileNavItemInTheActiveSubtree$ | async))
) {
  <nav
    [class.compound-third-level-navbar]="!showMobileNavVersion"
    [class.compound-third-level-navbar-mobile]="showMobileNavVersion"
    [attr.aria-label]="'third_level_navbar_label' | translate"
  >
    <div class="container-fluid" [ngClass]="showMobileNavVersion ? 'py-1' : 'py-2'">
      <ng-container *ngTemplateOutlet="showMobileNavVersion ? mobileVersion : desktopVersion"></ng-container>
    </div>
  </nav>
}

<ng-template #desktopVersion>
  @if ((currentNavContext$ | async) === NavigationContext.digitalProperty) {
    <div class="digital-asset-title">
      <h2>
        <span>{{ 'digital_asset' | translate }}: </span>{{ activeDigitalPropertyName$ | async }}
      </h2>
    </div>
  }

  <div class="menu" #navbarMenuItemsWrapper data-test-id="third-level-navbar-menu">
    @for (item of visibleNavbarItems; track item.routerLink) {
      <compound-navbar-link
        [navLink]="item.routerLink"
        [isActive]="item.isActive"
        [ariaLabel]="item.ariaLabel ? (item.ariaLabel | translate) : null"
      >
        {{ item.label | translate }}
      </compound-navbar-link>
    }
    @if (menuNavbarItems.length > 0) {
      <ds-dropdown class="dropdown-menu-items" [selectedValue]="(activeNavItem$ | async)?.id">
        <ds-dropdown-toggle
          [variant]="DsButtonVariants.microAction"
          label="{{ 'more' | translate }}"
          [icon]="Icons.Plus"
        ></ds-dropdown-toggle>
        <div ds-dropdown-menu>
          @for (item of menuNavbarItems; track item.routerLink) {
            <ds-dropdown-item
              [href]="item.routerLink"
              [label]="item.label | translate"
              [value]="item.id"
              [attr.aria-label]="item.ariaLabel ? (item.ariaLabel | translate) : null"
            ></ds-dropdown-item>
          }
        </div>
      </ds-dropdown>
    }
  </div>
  @if (gearRoutes$ | async; as gearRoutes) {
    @if (gearRoutes.length > 0) {
      <ds-dropdown
        class="gear-dropdown-menu"
        [selectedValue]="(activeNavItem$ | async)?.id"
        [ds-tooltip]="'scan_settings_tooltip_label' | translate"
        [tooltipPlacement]="DsTooltipPosition.bottom"
      >
        <ds-dropdown-toggle
          [variant]="DsButtonVariants.microAction"
          [icon]="Icons.Gear"
          [ariaLabel]="'scan_settings' | translate"
        ></ds-dropdown-toggle>
        <div ds-dropdown-menu>
          @for (item of gearRoutes; track item.routerLink) {
            <ds-dropdown-item
              [href]="item.routerLink"
              [label]="item.label | translate"
              [value]="item.id"
              [icon]="item.iconName"
            ></ds-dropdown-item>
          }
        </div>
      </ds-dropdown>
    }
  }
  <div class="ds-visually-hidden menu" aria-hidden="true">
    @for (item of navbarItems; track item.routerLink) {
      <compound-navbar-link #invisibleMenuItems data-test-id="invisible-menu-items">
        {{ item.label | translate }}
      </compound-navbar-link>
    }
    <ds-dropdown class="dropdown-menu-items" #invisibleMoreMenu data-test-id="invisible-more-menu">
      <ds-dropdown-toggle
        [variant]="DsButtonVariants.microAction"
        label="{{ 'more' | translate }}"
        [icon]="Icons.Plus"
      ></ds-dropdown-toggle>
      <div ds-dropdown-menu></div>
    </ds-dropdown>
    <div class="menu-space-between-items" #invisibleSpaceBetweenItems></div>
  </div>
</ng-template>

<ng-template #mobileVersion>
  <ds-breadcrumb
    [breadcrumbs]="breadcrumbs$ | async"
    [dividerIcon]="Icons.ChevronRight"
    [lastBold]="true"
    [maxCharacters]="25"
    class="p-0"
  />
</ng-template>
